import Content from './Content'

export default function Hero() {
  return (
    <div id='hero'>
      <Content />
    </div>
  )
}